import React from "react";

class SubTitle extends React.Component {

    componentDidMount() {

    }

  render() {
    const {title, direction} = this.props;
    return (
      <div className={`container rob-list__title rob-list__title--${direction}`}>
          <h1>{title}</h1>
      </div>
    )
  }
}

export default SubTitle;




// WEBPACK FOOTER //
// ./src/components/elements/SubTitle.js